import { applyTheme } from '@cloudscape-design/components/theming';
import { applyMode, Mode } from '@cloudscape-design/global-styles';
import { lightTheme, darkTheme } from "./themes";
import pkg from '../package.json';

import { Alert, AppLayout, Badge, Box, SideNavigation, Spinner, TopNavigation } from '@cloudscape-design/components';
import ManagementPage from './pages/management';
import { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './services/firebase';
import Login from './pages/login';

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    // Apply mode first, then theme
    applyMode(isDarkMode ? Mode.Dark : Mode.Light);
    applyTheme({ theme: isDarkMode ? darkTheme : lightTheme });
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const navigationUtils = [
    {
      type: 'menu-dropdown',
      text: 'Hallo ' + (user?.displayName || 'Benutzer'),
      description: user?.email,
      iconName: "user-profile",
      items: [
        {
          id: 'theme-toggle',
          text: isDarkMode ? 'Light Mode' : 'Dark Mode',
          iconName: isDarkMode ? 'view-full' : 'view-vertical'
        }
      ],
      onItemClick: ({ detail }) => {
        if (detail.id === 'theme-toggle') {
          setIsDarkMode(!isDarkMode);
        }
      }
    },
    {
      type: 'button',
      text: 'Abmelden',
      onClick: () => signOut(auth)
    },

  ]

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return (
    <Box textAlign="center" padding="xxl">
      <div role="status" aria-live="polite">
        <Spinner size="large" /> Lade...
      </div>
    </Box>
  );

  return (
    <div className="App">
      {user ? (
        <>
          <TopNavigation
            identity={{
              href: '/',
              title: 'Provider Capability Map',
              logo: { src: process.env.PUBLIC_URL + '/logo.png', alt: 'Provider Capability Map' },
            }}
            utilities={navigationUtils}
          />
          <AppLayout
            headerVariant="high-contrast"
            navigationOpen={true}
            notifications={<Alert
              type="info"
              header="Updates"
              dismissible
            >
              - Beziehungen können erstellt und gelöscht werden<br />
              - Dark Mode verfügbar über Benutzermenü
            </Alert>}
            navigation={
              <SideNavigation
                items={[
                  { type: 'link', text: `Management`, href: `#` },
                  { type: 'link', external: true, text: `Map`, href: `https://rheinenergie.gwc.qbilon.net/app/views/graph/59` },
                  { type: "divider" },
                  {
                    type: "link",
                    text: "Version",
                    info: <Badge color="grey">{pkg.version}</Badge>
                  },
                ]}
                activeHref='#'
              />
            }
            toolsHide
            content={
              <ManagementPage />
            }
          />
        </>
      ) : (<Login />)}
    </div>
  );
}

export default App;
